// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  path: "common",
  name: "Common",
  childRoutes: [],
};
